/**
 * SEO 配置 - 整合入口
 * 
 * 为了向后兼容，此文件整合所有子模块的 SEO 配置
 * 使用方式不变: $t('seo.home.title')
 */

import common from './seo/common'
import imageTools from './seo/image-tools'
import videoTools from './seo/video-tools'
import models from './seo/models'
import api from './seo/api'

// 支持的语言列表
const languages = ["en","zh","ja","ko","es","fr","de","ru","pt","it","ar","tw","pl","th","da","no","nl","id","tr"] as const

type LangKey = typeof languages[number]

// 合并所有子模块
const merged: Record<LangKey, Record<any, any>> = {} as any

for (const lang of languages) {
    merged[lang] = {
        ...(common as any)[lang],
        ...(imageTools as any)[lang],
        ...(videoTools as any)[lang],
        ...(models as any)[lang],
        ...(api as any)[lang],
    }
}

export default merged
